// MajangaService.js
import axios from 'axios';

const API_BASE_URL = 'https://api.jamboricg.com/api/majanga';
// const API_BASE_URL = 'http://127.0.0.1:8000/api/majanga';

export const ChelekoService = {
    // Get all community gangs
    getAllGangs: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/community-gangs/?specification=Cheleko`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get a specific community gang by ID
    getGangById: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/community-gangs/${id}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create a new community gang
    createGang: async (gangData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/community-gangs/`, gangData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update an existing community gang
    updateGang: async (id, gangData) => {
        try {
            const response = await axios.put(`${API_BASE_URL}/community-gangs/${id}/`, gangData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete a community gang
    deleteGang: async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/community-gangs/${id}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get gang members
    getGangMembers: async (gangId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/gang-memberships/by_gang/?gang_id=${gangId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },



   getGangRequest: async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/gang-memberships/`);
        // Return the results array directly, not the whole response object
        return response.data.results || response.data || [];
    } catch (error) {
        throw error.response?.data || error.message;
    }
},
   getGangRequestById: async (gangId) => {
    try {
        // Use the by_gang endpoint to get all memberships for a gang
        const response = await axios.get(`${API_BASE_URL}/gang-memberships/by_gang/?gang_id=${gangId}`);
        // Return results array
        return response.data.results || response.data || [];
    } catch (error) {
        throw error.response?.data || error.message;
    }
},

    // In ChelekoService.js
    approveGangRequest: async (requestId, payload) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/gang-memberships/${requestId}/approve/`,
                payload
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    rejectGangRequest: async (requestId, payload) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/gang-memberships/${requestId}/reject/`,
                payload
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteGangRequest: async (requestId) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/gang-memberships/${requestId}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
    getIndividualForms: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/cfn-forms/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
    getGangDetails: async (gangId) => {
        try {
          const response = await axios.get(`${API_BASE_URL}/community-gangs/${gangId}/`);
          return response.data;
        } catch (error) {
          console.error('Error fetching gang details:', error);
          throw error;
        }
      },
    
      addContribution: async (contributionData) => {
        try {
          const response = await axios.post(`${API_BASE_URL}/gang-contributions/`, contributionData);
          return response.data;
        } catch (error) {
          console.error('Error adding contribution:', error);
          throw error;
        }
      },
      getMemberContributionHistory: async (membershipId) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/gang-contributions/member_history/`,
                {
                    params: {
                        membership_id: membershipId
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
    deleteCFNForm: async (formId) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/cfn-forms/${formId}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

     // SPONSOR REQUEST FORMS
    getActiveForms: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/sponsor-request-forms/active/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    uploadSponsorForm: async (formData) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/sponsor-request-forms/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Token ${localStorage.getItem('token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    trackFormDownload: async (formId) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/sponsor-request-forms/${formId}/download/`
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteSponsorForm: async (formId) => {
        try {
            const response = await axios.delete(
                `${API_BASE_URL}/sponsor-request-forms/${formId}/`,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Token ${localStorage.getItem('token')}` 
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // SPONSOR REQUESTS
    getAllSponsorRequests: async (status = null) => {
        try {
            console.log("token here ....",localStorage.getItem('token'));
            const url = status 
                ? `${API_BASE_URL}/sponsor-requests/admin-view/?status=${status}`
                : `${API_BASE_URL}/sponsor-requests/admin-view/`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Token ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getSponsorRequestById: async (requestId) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/sponsor-requests/${requestId}/`
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    adminReviewRequest: async (requestId, payload) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/sponsor-requests/${requestId}/admin-review/`,
                payload,
                {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}` // Add auth token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // SPONSORSHIP RESPONSES
    getSponsorshipResponses: async (requestId) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/sponsorship-responses/?sponsor_request=${requestId}`
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
};

export default ChelekoService;